@let canvasTransform = transform();

<div class="flow-container relative h-full w-full overflow-hidden">
  @if (flowZoom.isZoomed()) {
    <button
      mat-stroked-button
      class="absolute top-4 left-1/2 z-10 -translate-x-1/2 rounded-[4rem]! bg-(--al-color-palette-dpblue900)! text-white! shadow-md"
      (click)="exitZoom()"
    >
      <mat-icon>zoom_out_map</mat-icon>
      <span>{{ 'I18N_FLOW.EXIT_ZOOM' | translate }}</span>
    </button>
  }

  @if (flow()) {
    <iot-platform-ui-flow-action-panel [config]="config()" (processAction)="processAction($event)" (resetFlow)="reset()" />

    <f-flow
      fDraggable
      fCache
      (fFullRendered)="editorLoaded()"
      appMouseTracker
      (mousePosition)="updateMouseTrackerPosition()"
      (fDragStarted)="onDragStarted($event)"
      (fDragEnded)="onDragEnded()"
      (fCreateConnection)="createConnection($event)"
      (fSelectionChange)="changeSelection($event)"
    >
      <f-background>
        <f-circle-pattern />
      </f-background>
      <f-magnetic-lines [threshold]="20" />
      <f-selection-area />

      <f-canvas fZoom [scale]="canvasTransform.scale" [position]="canvasTransform.position" [debounceTime]="fCanvasChangeEventDebounce">
        @for (connection of connections(); track connection.id) {
          <f-connection
            [fBehavior]="connection.behavior"
            [fConnectionId]="connection.id"
            [fOffset]="32"
            [fType]="connection?.type ?? 'segment'"
            [fSourceId]="connection.sourceId"
            [fTargetId]="connection.targetId"
            [class]="connection?.cssClassName"
          >
            <svg viewBox="0 0 700 700" fMarker [type]="eMarkerType.END" [height]="5" [width]="5" [refX]="4" [refY]="2.5" class="connection-marker">
              <path d="M0,0L700,350L0,700L150,350z" />
            </svg>

            <svg viewBox="0 0 700 700" fMarker [type]="eMarkerType.SELECTED_END" [height]="5" [width]="5" [refX]="4" [refY]="2.5" class="connection-marker">
              <path d="M0,0L700,350L0,700L150,350z" />
            </svg>

            @if (connection?.canRemove) {
              <div fConnectionContent position="0.5" class="connection-center">
                <button mat-icon-button class="icon-button delete-icon" (click)="removeConnection(connection.sourceId)" [matTooltip]="'Delete connection'">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </f-connection>
        }

        <f-snap-connection [fSnapThreshold]="50" fType="segment" />

        <f-connection-for-create fType="segment" [fOffset]="32">
          <svg
            id="normal_end"
            viewBox="0 0 700 700"
            fMarker
            [type]="eMarkerType.END"
            [height]="5"
            [width]="5"
            [refX]="4"
            [refY]="2.5"
            class="connection-marker"
          >
            <path d="M0,0L700,350L0,700L150,350z" />
          </svg>
        </f-connection-for-create>

        @for (node of basicNodes(); track node.id) {
          <div
            [ngClass]="{
              'f-node--with-add-button': $safeNavigationMigration(node?.canAddNode),
              'f-node--has-children': $safeNavigationMigration(node?.children?.length)
            }"
            fNode
            fDragHandle
            [fNodeDraggingDisabled]="!!node?.nodeDraggingDisabled"
            [fNodeId]="node.id"
            (click)="actualClick(node)"
            [fNodePosition]="node.position"
            [fNodeParentId]="$safeNavigationMigration(node?.parentId)"
            [class]="node?.cssClassName"
            [fIncludePadding]="!!node?.includePadding"
            [fAutoSizeToFitChildren]="$safeNavigationMigration(node?.autoSizeToFitChildren)"
            [fAutoExpandOnChildHit]="$safeNavigationMigration(node?.autoExpandOnChildHit)"
          >
            <iot-platform-ui-flow-node [node]="node" (dispatchEvent)="onDispatchEvent($event)" />

            @if (node?.canAddNode) {
              <button
                mat-icon-button
                (click)="addNode(node)"
                [disabled]="!canConfigure()"
                class="node-add-btn absolute! flex h-8! w-8! cursor-pointer items-center justify-center rounded-[50%]"
              >
                <mat-icon class="h-4.5 w-4.5 text-[18px]">add</mat-icon>
              </button>
            }

            @for (port of $safeNavigationMigration(node?.ports) | orderBy: 'order'; track $index) {
              @if (!port.internal) {
                @if (port.type === ViewPortType.INPUT) {
                  <iot-platform-ui-flow-input [input]="port" />
                } @else if (port.type === ViewPortType.OUTPUT) {
                  <iot-platform-ui-flow-output [output]="port" />
                }
              }
            }
          </div>
        }

        @for (node of groupNodes(); track node.id) {
          <div
            [ngClass]="{
              'f-node--with-add-button': $safeNavigationMigration(node?.canAddNode),
              'f-node--has-children': $safeNavigationMigration(node?.children?.length)
            }"
            fGroup
            (click)="actualClick(node)"
            [fGroupDraggingDisabled]="!!node?.nodeDraggingDisabled"
            fDragHandle
            [fGroupId]="node.id"
            [fGroupParentId]="$safeNavigationMigration(node?.parentId)"
            [class]="node?.cssClassName"
            [fGroupPosition]="node.position"
            [fIncludePadding]="!!node?.includePadding"
            [fAutoSizeToFitChildren]="$safeNavigationMigration(node?.autoSizeToFitChildren)"
            [fAutoExpandOnChildHit]="$safeNavigationMigration(node?.autoExpandOnChildHit)"
          >
            <iot-platform-ui-flow-group [node]="node" (dispatchEvent)="onDispatchEvent($event)" />

            @if (node?.canAddNode) {
              <button
                mat-icon-button
                (click)="addNode(node)"
                [disabled]="!canConfigure()"
                class="node-add-btn absolute! flex h-8! w-8! cursor-pointer items-center justify-center rounded-[50%]"
              >
                <mat-icon class="h-4.5 w-4.5 text-[18px]">add</mat-icon>
              </button>
            }

            @for (port of $safeNavigationMigration(node?.ports) | orderBy: 'order'; track $index) {
              @if (!port.internal) {
                @if (port.type === ViewPortType.INPUT) {
                  <iot-platform-ui-flow-input [input]="port" />
                } @else if (port.type === ViewPortType.OUTPUT) {
                  <iot-platform-ui-flow-output [output]="port" />
                }
              }
            }
          </div>
        }
      </f-canvas>
      <f-minimap class="f-minimap--left" [fMinSize]="2000" />
    </f-flow>
  } @else if (loading()) {
    <svg class="absolute top-[50%] left-[50%] h-12! w-12! -translate-3/6! animate-spin text-neutral-200!" viewBox="0 0 24 24">
      <circle class="bg-transparent! fill-transparent! opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  } @else {
    <mat-icon class="absolute top-[50%] left-[50%] h-60! w-60! -translate-3/6! text-[12rem]! text-neutral-200!"> web_asset_off </mat-icon>
  }
</div>
